import React, { Component } from 'react'
import ActionCreators from 'actions/ActionCreators'
import LiftControl from 'components/LiftControl'
import { createControlFactory } from 'components/Controls'
import Tip from 'components/TipControl'
import './LiftingParamtersPane.scss'

class LiftingParamtersPane extends Component {
    
    constructor(props) {
        super(props)
        this.Control = createControlFactory(ActionCreators.updateParameter)
    }

    _onLoadChange = (event) => {
        ActionCreators.updateParameter({
            load_floor: event.floor,
            load_elevator: event.type,
            load_loaders_count: event.loadersCount,
        })
    }

    _onUnloadChange = (event) => {
        ActionCreators.updateParameter({
            unload_floor: event.floor,
            unload_elevator: event.type,
            unload_loaders_count: event.loadersCount,
        })
    }

    _parseOptions = (options) => {
        return Object.values(options).map(option => {
            return {
                value: option.id,
                label: option.value,
            }
        })
    }

    _toggleLiftControl = (type, disabled) => {
        if (disabled && type === 'load') {
            ActionCreators.updateParameter({
                load_floor: undefined,
                load_elevator: [],
            })
        }

        if (disabled && type === 'unload') {
            ActionCreators.updateParameter({
                unload_floor: undefined,
                unload_elevator: [],
            })
        }

        switch (type) {
            case 'load':
                ActionCreators.updateParameter({
                    load_loaders: !disabled,
                    carrier_can_be_loader: false,
                    dismantling_assembling_furniture: false,
                    load_floor: '',
                })
                break
            case 'unload':
                ActionCreators.updateParameter({
                    unload_loaders: !disabled,
                    carrier_can_be_loader: false,
                    dismantling_assembling_furniture: false,
                    unload_floor: '',
                })
                break
        }
    }

    render() {
        const unloadElevatorOptions = this.props.parameters.unload_elevator.values
        const loadElevatorOptions = this.props.parameters.load_elevator.values

        const unloadLoadersOptions = this.props.parameters.unload_loaders_count.values
        const loadLoadersOptions = this.props.parameters.load_loaders_count.values

        const loadersChecked =
            (this.props.parameters.load_loaders && this.props.parameters.load_loaders.get('value')) ||
            (this.props.parameters.unload_loaders && this.props.parameters.unload_loaders.get('value'))

        let loadElevatorValue = 0
        let unloadElevatorValue = 0

        if (this.props.parameters.load_elevator.value && this.props.parameters.load_elevator.value.length > 0) {
            loadElevatorValue = this.props.parameters.load_elevator.value[0]
        }

        if (this.props.parameters.unload_elevator.value && this.props.parameters.unload_elevator.value.length > 0) {
            unloadElevatorValue = this.props.parameters.unload_elevator.value[0]
        }

        return (
            <div className="LiftingParamtersPane">
                <LiftControl
                    className="LiftingParamtersPane-field"
                    label="На погрузке"
                    onChange={this._onLoadChange}
                    floor={this.props.parameters.load_floor.value}
                    type={loadElevatorValue}
                    loadersOptions={this._parseOptions(loadLoadersOptions)}
                    options={this._parseOptions(loadElevatorOptions)}
                    disableControl={!this.props.parameters.load_loaders.value}
                    toggleLiftControl={this._toggleLiftControl.bind(this, 'load')}
                />
                <LiftControl
                    className="LiftingParamtersPane-field"
                    label="На выгрузке"
                    onChange={this._onUnloadChange}
                    floor={this.props.parameters.unload_floor.value}
                    type={unloadElevatorValue}
                    options={this._parseOptions(unloadElevatorOptions)}
                    loadersOptions={this._parseOptions(unloadLoadersOptions)}
                    disableControl={!this.props.parameters.unload_loaders.value}
                    toggleLiftControl={this._toggleLiftControl.bind(this, 'unload')}
                />
                <div style={{ marginTop: '10px' }}>
                    <this.Control
                        disabled={!loadersChecked}
                        type="checkbox"
                        label={this.props.parameters.carrier_can_be_loader.title}
                        attribute={this.props.parameters.carrier_can_be_loader}
                    />
                </div>
                <div className="LiftingParamtersPane-service">
                    {
                        this.props.parameters.dismantling_assembling_furniture ?
                            <div style={{ minWidth: '400px' }}>
                                <this.Control
                                    disabled={!loadersChecked}
                                    type="checkbox"
                                    label={this.props.parameters.dismantling_assembling_furniture.title}
                                    attribute={this.props.parameters.dismantling_assembling_furniture}
                                />
                                <Tip label={this.props.parameters.dismantling_assembling_furniture.tip}/>
                            </div>
                            : null
                    }
                    {
                        this.props.parameters.packing_services ?
                            <div style={{ minWidth: '400px' }} className="LiftingParamtersPane-serviceBlock">
                                <this.Control
                                    disabled={!loadersChecked}
                                    type="checkbox"
                                    label={this.props.parameters.packing_services.title}
                                    attribute={this.props.parameters.packing_services}/>
                                <Tip label={this.props.parameters.packing_services.tip}/>
                            </div> : null
                    }
                </div>
            </div>
        )
    }

}

export default LiftingParamtersPane



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/LiftingParamtersPane.js